module.exports = __webpack_public_path__ + "static/media/ft-reviews.f354e675.svg";